import { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Download from "@store/Components/Icons/Download";
import { TYPOGRAPHY } from "@store/theme/design";
import { actionLinkStyles } from "@store/theme/mixins/typography";
import { css } from "styled-components";

export interface StoreProductResourcesProps {
    list?: InjectableCss;
    listItem?: InjectableCss;
    resourceLink?: LinkPresentationProps;
}

export const productResourcesProps: StoreProductResourcesProps = {
    list: {
        css: css`
            max-width: 400px;

            &:last-child {
                border-bottom: 1px solid ${getColor("common.border")};
            }
        `,
    },
    listItem: {
        css: css`
            position: relative;
            padding: 15px 12px 15px 0;
            border-top: 1px solid ${getColor("common.border")};
            line-height: 1;
        `,
    },
    resourceLink: {
        css: css`
            ${actionLinkStyles()}
            width: 100%;
            justify-content: space-between;
        `,
        icon: {
            position: "right",
            iconProps: {
                src: Download,
                size: 24,
                color: "inherit",
                css: css`
                    margin: 0;
                `,
            },
        },
        typographyProps: {
            lineHeight: TYPOGRAPHY.lineHeight.small,
            css: css`
                word-break: break-word;
                margin-right: 12px;
            `,
        },
    },
};
